import React, { useState, useEffect, useMemo } from "react";
import "./DoctorDataView.css";
import Avatar from "../../assets/avatar.png";
import { ToggleButton, ToggleButtonGroup, Spinner } from "react-bootstrap";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { FaRegEye } from "react-icons/fa6";
import { FaUserNurse, FaUserMd, FaHospitalUser, FaClinicMedical, FaNotesMedical } from "react-icons/fa";
import { apiUrl, REGISTRATION_SOURCES } from "../../config/appConfig";

const CustomModal = ({ showModal, onClose, details, initialImageUrl }) => {
  const [Imgurl, setImgUrl] = useState(initialImageUrl || Avatar);
  const capitalize = (str) => str?.charAt(0)?.toUpperCase() + str?.slice(1);

  useEffect(() => {
    // If the table already resolved this professional's image, show it
    // instantly instead of re-fetching a presigned URL.
    if (initialImageUrl) {
      setImgUrl(initialImageUrl);
      return;
    }

    const fetchUrl = async () => {
      if (!details || !details?.profile_picture_url) {
        setImgUrl(Avatar);
        return;
      }
      try {
        const res = await axios.post(
          apiUrl('/professionals/view-url'),
          { key: details?.profile_picture_url, content_type: "image/jpeg" },
          { headers: { accept: "application/json", "Content-Type": "application/json" } }
        );
        setImgUrl(res.data.data.view_url || Avatar);
      } catch (err) {
        console.error("Error fetching presigned URL:", err);
        setImgUrl(Avatar);
      }
    };
    fetchUrl();
  }, [details, initialImageUrl]);

  if (!details) return null;

  return (
    <Modal
      className="viewModal"
      show={showModal}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton />

      <Modal.Body className="text-center">
        <div className="viewModal-content">
          <div className="profileImg">
            <img
              src={Imgurl}
              alt="Profile"
              className="img-fluid"
              loading="eager"
              decoding="async"
              onError={(e) => {
                e.target.src = Avatar;
              }}
            />
          </div>
          <h5 className="modal-title">{capitalize(details?.full_name) || "Details"}</h5>
          <div className="text-start mt-4 detailsWrapper">
            <div className="row mb-2">
              <div className="col-6">
                <strong>Phone:</strong>
              </div>
              <div className="col-6">{details?.contact_phone || "N/A"}</div>
            </div>
            <div className="row mb-2">
              <div className="col-6">
                <strong>Bio:</strong>
              </div>
              <div className="col-6">{capitalize(details?.short_bio) || "N/A"}</div>

            </div>

            {details?.role_id === 8 && (
              <>
                {details?.center && (
                  <div className="row mb-2">
                    <div className="col-6">
                      <strong>Center Name:</strong>
                    </div>
                    <div className="col-6">{capitalize(details.center)}</div>
                  </div>
                )}
                {details?.center_type && (
                  <div className="row mb-2">
                    <div className="col-6">
                      <strong>Center Type:</strong>
                    </div>
                    <div className="col-6">{details.center_type}</div>
                  </div>
                )}
                {details?.street && (
                  <div className="row mb-2">
                    <div className="col-6">
                      <strong>Street:</strong>
                    </div>
                    <div className="col-6">{capitalize(details.street)}</div>
                  </div>
                )}
                {details?.area && (
                  <div className="row mb-2">
                    <div className="col-6">
                      <strong>Area:</strong>
                    </div>
                    <div className="col-6">{capitalize(details.area)}</div>
                  </div>
                )}
                {details?.center_address && (
                  <div className="row mb-2">
                    <div className="col-6">
                      <strong>Center Address:</strong>
                    </div>
                    <div className="col-6">{details.center_address}</div>
                  </div>
                )}
              </>
            )}

            {details?.role_id !== 8 && Array.isArray(details?.hospital_details) && details?.hospital_details?.length > 0 && (
              <div className="row mb-2">
                <div className="col-12 mb-1 px-0">
                  <strong>Hospital Details:</strong>
                </div>
                <div className="col-12 px-0 pb-1">
                  <div className="row mb-1 bg-light py-1">
                    <div className="col-6 fw-semibold">Names</div>
                    <div className="col-6 fw-semibold">Location</div>
                  </div>
                  {details?.hospital_details?.map((hospital, index) => (
                    <div className={`row mb-1 ${index === 0 ? "" : "border-top pt-1"}`} key={index}>
                      <div className="col-6">{capitalize(hospital.name)} -</div>
                      <div className="col-6"> {hospital?.address}
                        {index < details?.hospital_details?.length - 1 ? ", " : ""}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {details?.pharmacy_name && (
              <div className="row mb-2">
                <div className="col-6">
                  <strong>Pharmacy:</strong>
                </div>
                <div className="col-6">{capitalize(details?.pharmacy_name)}</div>
              </div>
            )}
            {details?.specialty && (
              <div className="row mb-2">
                <div className="col-6">
                  <strong>Specialty:</strong>
                </div>
                <div className="col-6">{capitalize(details?.specialty)}</div>
              </div>
            )}
            {details?.location && (
              <div className="row mb-2">
                <div className="col-6">
                  <strong>Location:</strong>
                </div>
                <div className="col-6">{capitalize(details?.location)}</div>
              </div>
            )}
            {details?.longitude && (
              <div className="row mb-2">
                <div className="col-6">
                  <strong>longitude(X):</strong>
                </div>
                <div className="col-6">{capitalize(details?.longitude)}</div>
              </div>
            )}
            {details?.latitude && (
              <div className="row mb-2">
                <div className="col-6">
                  <strong>latitude(Y):</strong>
                </div>
                <div className="col-6">{capitalize(details?.latitude)}</div>
              </div>
            )}
            {details?.years_of_experience != null && (
              <div className="row mb-2">
                <div className="col-6">
                  <strong>Experience:</strong>
                </div>
                <div className="col-6">{details?.years_of_experience} yrs</div>
              </div>
            )}
            <div className="row mb-2">
              <div className="col-6">
                <strong>Interested in Online:</strong>
              </div>
              <div className="col-6">
                {details?.online_consultation ? "Yes" : "No"}
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-6">
                <strong>Region:</strong>
              </div>
              <div className="col-6">{capitalize(details?.region) || "Baghdad"}</div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const DoctorDataView = () => {
  const [page, setPage] = useState(1);
  const [tabActive, setTabActive] = useState("Doctor Online Consultation");
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [imageUrls, setImageUrls] = useState({}); // Cache for image URLs: { key: url }
  const [loadingImages, setLoadingImages] = useState(new Set()); // Track which images are loading
  const [showModal, setShowModal] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null); // store API details
  const itemsPerPage = 10;

  const fetchPresignedUrl = async (key) => {
    if (!key) return null;
    try {
      const res = await axios.post(
        apiUrl('/professionals/view-url'),
        { key, content_type: "image/jpeg" },
        {
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return res.data.data.view_url || null;
    } catch (err) {
      console.error("Error fetching presigned URL:", err);
      return null;
    }
  };

  const fetchData = async (roleId) => {
    setLoading(true);
    try {
      const res = await axios.get(
        apiUrl('/professionals'),
        {
          // Main registry only: consultation link registrations are on /admin-view-consultation-registered.
          params: { page, limit: itemsPerPage, role_id: roleId, registration_source: REGISTRATION_SOURCES.MAIN_PLATFORM },
          headers: { accept: "application/json" },
        }
      );

      const list = res.data?.data?.data || [];
      const totalCount = res.data?.data?.total || 0;

      // Show data immediately without waiting for images
      setData(list);
      setTotal(totalCount);
      setLoading(false);

      // Load images asynchronously in the background
      // Use functional update to get current imageUrls state
      setImageUrls((prevUrls) => {
        // Batch fetch all presigned URLs in parallel
        const imagesToLoad = list
          .filter((doc) => doc.profile_picture_url && !prevUrls[doc.profile_picture_url])
          .map((doc) => doc.profile_picture_url);

        // Mark images as loading
        if (imagesToLoad.length > 0) {
          setLoadingImages((prevLoading) => {
            const newSet = new Set(prevLoading);
            imagesToLoad.forEach((key) => newSet.add(key));
            return newSet;
          });
        }

        // Start fetching URLs for images that aren't cached
        const imageUrlPromises = list
          .filter((doc) => doc.profile_picture_url)
          .map(async (doc) => {
            const key = doc.profile_picture_url;
            // Skip if already cached
            if (prevUrls[key]) {
              return { key, url: prevUrls[key] };
            }
            const url = await fetchPresignedUrl(key);
            return { key, url };
          });

        // Update images as they load - use functional update to avoid stale closure
        Promise.allSettled(imageUrlPromises).then((results) => {
          setImageUrls((currentUrls) => {
            const newImageUrls = { ...currentUrls };
            results.forEach((result) => {
              if (result.status === "fulfilled" && result.value?.url) {
                newImageUrls[result.value.key] = result.value.url;
              }
            });
            return newImageUrls;
          });

          // Remove loaded images from loading set
          setLoadingImages((prev) => {
            const newSet = new Set(prev);
            results.forEach((result) => {
              if (result.status === "fulfilled" && result.value?.key) {
                newSet.delete(result.value.key);
              }
            });
            return newSet;
          });
        });

        // Return unchanged URLs (we'll update them in the Promise handler)
        return prevUrls;
      });
    } catch (err) {
      console.error("Error fetching data:", err);
      setData([]);
      setTotal(0);
      setLoading(false);
    }
  };

  useEffect(() => {
    const roleMap = {
      "Doctor Online Consultation": 4,
      Pharmacy: 5,
      "Doctor Home Consultation": 6,
      Nurse: 7,
      "Physiotherapy / Imaging / Lab": 8,
    };
    fetchData(roleMap[tabActive] || 4);
  }, [tabActive, page]);

  const handleToggleChange = (val) => {
    // Clear data immediately to prevent flickering
    setData([]);
    setTotal(0);
    setImageUrls({}); // Clear image cache when switching tabs
    setLoadingImages(new Set()); // Clear loading images when switching tabs
    setTabActive(val);
    setPage(1);
  };

  const totalPages = Math.ceil(total / itemsPerPage);

  const showHospitalColumns = ["Doctor Online Consultation", "Doctor Home Consultation", "Nurse"].includes(tabActive);
  const showSpecialtyColumn = ["Doctor Online Consultation", "Doctor Home Consultation"].includes(tabActive);
  const showExperienceColumn = showSpecialtyColumn;

  const tableRows = useMemo(() => {
    if (!Array.isArray(data)) return [];

    // Return one row per professional, with all hospital details in the same row
    return data.map((doc) => ({ doc }));
  }, [data]);

  let columnCount = 9; // #, Name, Type, Location, Region, Phone, Bio, Registered, Action
  if (showSpecialtyColumn) columnCount += 1; // specialty
  if (showExperienceColumn) columnCount += 1; // experience
  if (tabActive === "Physiotherapy / Imaging / Lab") columnCount += 2; // street and area

  // Fetch full details when View is clicked
  const handleViewClick = async (id) => {
    try {
      const res = await axios.get(
        apiUrl(`/professionals/${id}`),
        {
          headers: { accept: "application/json" },
        }
      );
      setSelectedDetail(res.data?.data || null);
      setShowModal(true);
    } catch (err) {
      console.error("Error fetching detail:", err);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedDetail(null);
  };

  const capitalize = (str) => {
    if (str === null || str === undefined) return "";
    if (typeof str !== "string") {
      if (str === null || str === undefined) return "";
      return String(str);
    }
    return str?.charAt(0)?.toUpperCase() + str?.slice(1);
  };

  // Safe truncate function
  const truncate = (str, length = 18) => {
    if (str === null || str === undefined) return "";
    if (typeof str !== "string") {
      if (str === null || str === undefined) return "";
      str = String(str);
    }
    return str?.length > length ? str.slice(0, length) + " ..." : str;
  };

  // Format the exact registration date and time
  const formatDateTime = (value) => {
    if (!value) return "N/A";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "N/A";
    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="apt-main-content" style={{ minHeight: "100vh" }}>
      <div className="innerWrapper">
        <div className="d-flex justify-content-between align-items-center mb-4 tblHdBlock">
          <div className="dataPageToggle">
            <ToggleButtonGroup
              type="radio"
              name="tableData"
              value={tabActive}
              onChange={handleToggleChange}
            >
              <ToggleButton
                id="doctor"
                value="Doctor Online Consultation"
                variant={
                  tabActive === "Doctor Online Consultation" ? "primary" : "outline-primary"
                }
                style={{ minWidth: 80 }}
              >
                <FaUserMd className="me-2" />
                Doctor Online Consultation
              </ToggleButton>
              <ToggleButton
                id="pharmacy"
                value="Pharmacy"
                variant={
                  tabActive === "Pharmacy" ? "primary" : "outline-primary"
                }
                style={{ minWidth: 80 }}
              >
                <FaNotesMedical className="me-2" />
                Pharmacy
              </ToggleButton>
              <ToggleButton
                id="doctor-home"
                value="Doctor Home Consultation"
                variant={
                  tabActive === "Doctor Home Consultation" ? "primary" : "outline-primary"
                }
                style={{ minWidth: 80 }}
              >
                <FaClinicMedical className="me-2" />
                Doctor Home Consultation
              </ToggleButton>
              <ToggleButton
                id="nurse"
                value="Nurse"
                variant={
                  tabActive === "Nurse" ? "primary" : "outline-primary"
                }
                style={{ minWidth: 80 }}
              >
                <FaUserNurse className="me-2" />
                Nurse
              </ToggleButton>
            <ToggleButton
              id="physiotherapy"
              value="Physiotherapy / Imaging / Lab"
              variant={
                tabActive === "Physiotherapy / Imaging / Lab" ? "primary" : "outline-primary"
              }
              style={{ minWidth: 80 }}
            >
              <FaHospitalUser className="me-2" />
              Physiotherapy / Imaging / Lab
            </ToggleButton>
            </ToggleButtonGroup>
          </div>
        </div>

        <div className="apt-appointments-section">
          <div className="apt-appointments-table">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>{tabActive === "Physiotherapy / Imaging / Lab" ? "Center Name" : "Full Name"}</th>
                  <th>
                    {tabActive === "Physiotherapy / Imaging / Lab"
                      ? "Center Type"
                      : tabActive === "Nurse"
                        ? "Hospital"
                        : showHospitalColumns
                          ? "Hospital"
                          : "Pharmacy Name"}
                  </th>
                  {tabActive === "Physiotherapy / Imaging / Lab" && <th>Street</th>}
                  {tabActive === "Physiotherapy / Imaging / Lab" && <th>Area</th>}
                  <th>
                    {tabActive === "Physiotherapy / Imaging / Lab"
                      ? "Location"
                      : showHospitalColumns
                        ? "Location"
                        : "Location"}
                  </th>
                  <th>Region</th>
                  {showSpecialtyColumn && <th>Specialty</th>}
                  <th>Phone</th>
                  <th>Bio</th>
                  {showExperienceColumn && <th>Experience</th>}
                  <th>Registered</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={columnCount} style={{ textAlign: "center", padding: "40px" }}>
                      <div className="d-flex justify-content-center align-items-center gap-2">
                        <Spinner animation="border" variant="primary" />
                        <span>Loading data...</span>
                      </div>
                    </td>
                  </tr>
                ) : Array.isArray(tableRows) && tableRows.length > 0 ? (
                  tableRows.map((row, idx) => {
                    const { doc } = row;
                    const rowKey = doc?.id || `${idx}`;
                    
                    // Get all hospital details for this professional
                    const hospitalDetails = Array.isArray(doc?.hospital_details) && doc.hospital_details.length
                      ? doc.hospital_details
                      : [];
                    
                    const locationDisplay = tabActive === "Physiotherapy / Imaging / Lab"
                      ? (doc?.center_address ? (
                          <span className="cell-ellipsis" title={doc.center_address}>
                            {doc.center_address}
                          </span>
                        ) : "N/A")
                      : showHospitalColumns
                        ? (hospitalDetails.length > 0 ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                              {hospitalDetails.map((h, i) => (
                                <div key={i} className="cell-ellipsis" title={h.address || "N/A"}>
                                  {h.address || "N/A"}
                                </div>
                              ))}
                            </div>
                          ) : "N/A")
                        : (doc?.location ? (
                            <span className="cell-ellipsis" title={capitalize(doc.location)}>
                              {capitalize(doc.location)}
                            </span>
                          ) : "N/A");

                    return (
                    <tr key={rowKey}>
                      <td>{(page - 1) * itemsPerPage + idx + 1}</td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <img
                            src={
                              doc.profile_picture_url && imageUrls[doc.profile_picture_url]
                                ? imageUrls[doc.profile_picture_url]
                                : Avatar
                            }
                            alt="avatar"
                            height={32}
                            width={32}
                            style={{ objectFit: "cover", borderRadius: "50%" }}
                            onError={(e) => {
                              e.target.src = Avatar;
                            }}
                            onLoad={() => {
                              if (doc.profile_picture_url) {
                                setLoadingImages((prev) => {
                                  const newSet = new Set(prev);
                                  newSet.delete(doc.profile_picture_url);
                                  return newSet;
                                });
                              }
                            }}
                          />
                          <span>
                            {tabActive === "Physiotherapy / Imaging / Lab"
                              ? capitalize(doc?.center) || "N/A"
                              : capitalize(doc?.full_name) || "N/A"}
                          </span>
                        </div>
                      </td>
                      <td>
                        {tabActive === "Physiotherapy / Imaging / Lab"
                          ? (doc?.center_type ? (
                              <span className="cell-ellipsis" title={capitalize(doc.center_type)}>
                                {capitalize(doc.center_type)}
                              </span>
                            ) : "N/A")
                          : showHospitalColumns
                            ? (hospitalDetails.length > 0 ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                  {hospitalDetails.map((h, i) => (
                                    <div key={i} className="cell-ellipsis" title={capitalize(h.name)}>
                                      {capitalize(h.name)}
                                    </div>
                                  ))}
                                </div>
                              ) : "N/A")
                            : (doc?.pharmacy_name ? (
                                <span className="cell-ellipsis" title={capitalize(doc.pharmacy_name)}>
                                  {capitalize(doc.pharmacy_name)}
                                </span>
                              ) : "N/A")}
                      </td>
                      {tabActive === "Physiotherapy / Imaging / Lab" && (
                        <td>{capitalize(doc?.street) || "N/A"}</td>
                      )}
                      {tabActive === "Physiotherapy / Imaging / Lab" && (
                        <td>{capitalize(doc?.area) || "N/A"}</td>
                      )}
                      <td>{locationDisplay}</td>
                      <td>{capitalize(doc?.region) || "Baghdad"}</td>
                      {showSpecialtyColumn && (
                        <td>{capitalize(doc?.specialty) || "N/A"}</td>
                      )}
                      <td>{doc.contact_phone || "N/A"}</td>
                      <td style={{ maxWidth: 180, cursor: "pointer" }} title={doc?.short_bio || "N/A"}>
                        {truncate(doc?.short_bio) || "N/A"}
                      </td>
                      {showExperienceColumn && (
                        <td>
                          {doc.years_of_experience != null
                            ? doc.years_of_experience + " yrs"
                            : "N/A"}
                        </td>
                      )}
                      <td style={{ whiteSpace: "nowrap" }}>
                        {formatDateTime(doc?.created_at)}
                      </td>
                      <td>
                        <div className="d-flex gap-3 align-items-center">
                          <span
                            className="text-primary"
                            style={{ cursor: "pointer" }}
                            title="View details"
                            onClick={() => handleViewClick(doc.id)}
                          >
                            <FaRegEye size={20} />
                          </span>
                        </div>
                      </td>
                    </tr>
                  )})
                ) : (
                  <tr>
                    <td colSpan={columnCount} style={{ textAlign: "center" }}>
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="apt-pagination">
            <span className="apt-pagination-info">
              Showing {(page - 1) * itemsPerPage + 1}-
              {Math.min(page * itemsPerPage, total)} of {total}
            </span>
            <div className="apt-pagination-controls">
              <button
                className="apt-pagination-btn"
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
              >
                &lt; Previous
              </button>
              <div className="apt-page-numbers">
                {[...Array(totalPages)].map((_, idx) => (
                  <button
                    key={idx + 1}
                    className={`apt-page-btn${page === idx + 1 ? " active" : ""
                      }`}
                    onClick={() => setPage(idx + 1)}
                  >
                    {idx + 1}
                  </button>
                ))}
              </div>
              <button
                className="apt-pagination-btn apt-next-btn"
                onClick={() => setPage(page + 1)}
                disabled={page === totalPages}
              >
                Next &gt;
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for details */}
      {showModal && selectedDetail && (
        <CustomModal
          showModal={showModal}
          onClose={handleCloseModal}
          details={selectedDetail} // pass details to modal
          initialImageUrl={
            selectedDetail?.profile_picture_url
              ? imageUrls[selectedDetail.profile_picture_url]
              : ""
          }
        />
      )}
    </div>
  );
};

export default DoctorDataView;

